import { asField, BasicText } from 'informed';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import './styles/formFieldStyles.css';

const TextInput = asField((props) => {
  const { noBorder, validationSuccessText, ...informedProps } = props;
  const { field, fieldState } = informedProps;
  const { error, value } = fieldState;
  const success = value && !error;
  const statusClass = success ? 'success' : error && 'error';

  return (
    <Fragment>
      <BasicText
        {...informedProps}
        aria-invalid={!!error}
        className={`custom-field ${noBorder ? 'no-border' : ''} ${
          statusClass || ''
        }`}
        id={field}
      />
      {success && validationSuccessText ? (
        <small className="text-green-3">{validationSuccessText}</small>
      ) : null}
      {error && <small className="text-red-3">{error}</small>}
    </Fragment>
  );
});

TextInput.defaultProps = {
  noBorder: false,
  type: 'text',
  validationSuccessText: '',
};

TextInput.propTypes = {
  field: PropTypes.string.isRequired,
  noBorder: PropTypes.bool,
  type: PropTypes.string,
  validationSuccessText: PropTypes.string,
};

export default TextInput;
